import Vue from 'vue';

export default {
  name: 'Capture',
  props: ['dataObj'],
  data: function () {
    return {
      bShowConfirm: false,
	  readings: [],
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.init();
    this.$root.$on('capture_updated', this.init);
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.readings = this.dataObj;
      });
    },
  },
}

